import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `currentColor` : `var(--color-${color})`;
};
const SvgFacebookColorIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path fill={getFillColor(props.color) === "currentColor" ? `var(--color-facebook)` : getFillColor(props.color)}
      d="M32 16C32 7.16347 24.8365 9.83819e-06 16 9.83819e-06C7.16346 9.83819e-06 0 7.16347 0 16C0 23.5037 5.16576 29.7998 12.1348 31.5288V20.8894H8.83546V16H12.1348V13.8932C12.1348 8.44731 14.5993 5.92315 19.9459 5.92315C20.9595 5.92315 22.7085 6.12187 23.4241 6.32065V10.7529C23.0464 10.7132 22.3905 10.6933 21.5756 10.6933C18.9521 10.6933 17.9384 11.687 17.9384 14.2709V16H23.1645L22.2668 20.8894H17.9384V31.8828C25.8607 30.926 32 24.1804 32 16Z"/>
    <path fill={getFillColor(props.color) === "currentColor" ? `var(--color-facebook-logo-white)` : getFillColor(props.color)}
      d="M22.2667 20.8894L23.1646 16H17.9384V14.2708C17.9384 11.687 18.9521 10.6933 21.5756 10.6933C22.3905 10.6933 23.0464 10.7131 23.4241 10.7529V6.32067C22.7085 6.12189 20.9595 5.9231 19.9459 5.9231C14.5994 5.9231 12.1348 8.44732 12.1348 13.8932V16H8.83545V20.8894H12.1348V31.5289C13.3727 31.8359 14.6671 32 16 32C16.6562 32 17.3029 31.9596 17.9384 31.8828V20.8894H22.2667Z"/>
  </svg>
);

export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}

const SvgFacebookColorStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgFacebookColorIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const FacebookColorIcon: any = SvgFacebookColorStyle;
export default FacebookColorIcon;
